import React, { useState } from 'react'
import './Selector.css'


const Selector = ({ groups, selectedItem, placeholder, onChangeAction, user = false }) => {
	const [isDropDownOpened, setIsDropDownOpened] = useState(false)
	const [selectedOption, setSelectedOption] = useState(selectedItem ? selectedItem : undefined)
	const handleSelect = (option) => {
		setSelectedOption(option)
		setIsDropDownOpened(false)
		onChangeAction(option)
	}
	return <div className='selectorInput'>
		<div
			className='selectorInput__label'
			onClick={ () => setIsDropDownOpened(!isDropDownOpened) }
		>
			{ selectedOption?.iconDefault && <div className={ `selectorInput__option_${ selectedOption.name }` }/> }
			{ selectedOption?.title ? selectedOption.title : selectedOption?.name ? selectedOption.name  : placeholder }
		</div>

		{ isDropDownOpened && <div className='selectorInput__dropdown' >
			{groups.map((option, index) => (
				<div
					className='selectorInput__option'
					key={ index }
					onClick={ () => handleSelect(option) }
				>
					{user && (
						<img src={user}></img>
					)}
					<div>
					{ option.iconDefault && <div className={`selectorInput__option_${ option.name }`}/> }
					{ option.title ?? option.name }
					{user && (
						<span>Здесь вы можете записаться ко мне на занятие</span>
					)}
					</div>
				</div>
			))}

		</div> }
	</div>
}

Selector.defaultProps = {
	placeholder: 'Выберите',
}

export default Selector
